import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown'
import NavDropdown from 'react-bootstrap/NavDropdown'

import { navigateTo } from '../../utils/Navigation'
import { actionCreators as notificationActions } from '../../store/Notifications';
import { actionCreators as accountActions } from '../../store/Account';
import { actionCreators as themeOptionsActions } from '../../store/Theme';


class Header extends React.Component {

	constructor(props) {
		super(props);
		this.props = props;

		this.changeSelectedCustomer = this.changeSelectedCustomer.bind(this);
		this.renderAuthenticatedMenu = this.renderAuthenticatedMenu.bind(this);
		this.renderUnauthenticatedMenu = this.renderUnauthenticatedMenu.bind(this);
		this.renderAuthorizedMenuItems = this.renderAuthorizedMenuItems.bind(this);
		this.renderLoadTimeReporting = this.renderLoadTimeReporting.bind(this);
		this.setTheme = this.setTheme.bind(this);

		this.themeOptions = [];
	}


	setTheme(event, themeName) {
		// thema huidige rapport aanpassen
		this.props.setTheme(themeName);

		// thema opslaan voor huidige gebruiker
		const url = 'account/SetTheme/' + themeName + '/';
		let postData = { Theme: themeName };
		fetch(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(postData) })
			.then(response => {
				if (response.ok) {
					console.log(response);
				}
			}
		);
	}


	changeSelectedCustomer(event, option) {
		this.props.setCustomerInformation(option.key, option.text)
			.then(() => { window.location.reload(); });
	}


	getCustomerControl() {
		var customers = this.props.customers;
		if (customers.length > 1) {
			var selectedKey = 0;

			if (this.props.activeCustomerId === 0 || this.props.activeCustomerId === undefined) {
				selectedKey = customers[0].customerId
			}
			else {
				selectedKey = this.props.activeCustomerId
			}

			var options = customers.map(i => { return { key: i.customerId, text: i.customerName } });

			return <Dropdown
				defaultSelectedKey={selectedKey}
				styles={this.interceptStyle}
				options={options}
				onChange={this.changeSelectedCustomer}
			/>
		}
		else {
			if (customers.length > 0)
				return <div>{customers[0].customerName}</div>
		}
	}


	buildAuthenticatedMenu = () => {
		return [
			{
				key: 'customername',
				text: '',
				iconOnly: false,
				buttonStyles: this.interceptStyle,
				onRenderChildren: () => this.getCustomerControl()
			},
			{
				key: '3',
				// Set to null if you have submenus that want to hide the down arrow.
				onRenderMenuIcon: () => null,
				// Any renderer
				onRenderChildren: () => null,
				name: '',
				buttonStyles: this.interceptStyle,
				iconOnly: true,
				subMenuProps: {
					items: [
						{
							key: 'settings',
							name: this.props.translate('settings.settings'),
							onClick: (e) => { navigateTo(e, "/settings") }
						},
						{
							key: 'signOutMessage',
							name: this.props.translate('signOut'),
							onClick: (e) => { navigateTo(e, "/account/logout") }
						}
					]
				}
			}
		]
	}

	buildUnauthenticatedMenu = () => {
		return [
			{
				key: '3',
				name: this.props.translate('signIn'),
				onClick: (e) => { navigateTo(e, "/account/login") }
			},
			{
				key: '4',
				// Set to null if you have submenus that want to hide the down arrow.
				onRenderMenuIcon: () => null,
				// Any renderer
				name: this.props.translate('registration.register'),
				iconOnly: false,
				onClick: (e) => { navigateTo(e, "/register") }
			}
		]
	}


	items = () => {
		return [
			{
				//
				key: 'menu',
				// Set to null if you have submenus that want to hide the down arrow.
				onRenderMenuIcon: () => null,
				onRenderChildren: () => (<div className="menuToggle" data-children-count="1">< input id="menuToggleInput" type="checkbox" /><span></span><span></span><span></span></div>),
				// Any renderer
				buttonStyles: this.interceptStyle,
				name: '',
				className: 'menu-toggle',
				iconOnly: true,
				onClick: (e) => {
					var menu = document.getElementById("sideBarMenu");
					var toggle = document.getElementById("menuToggleInput");
					if (toggle.checked) {
						menu.className += " active";

					}
					else {
						//alert("not checked");
						menu.className = menu.className.replace(" active", "");
					}

				}

			},
			{
				// Set to null if you have submenus that want to hide the down arrow.
				onRenderMenuIcon: () => null,
				buttonStyles: this.interceptStyle,
				onClick: (e) => navigateTo(e, '/'),
				// Any renderer
				onRenderChildren: () => null,
				key: 'logo',
				name: '',
				iconOnly: true,
			}
		]
	}


	getActionId = () => {
		// bepaal action id
		var urlParts = window.location.href.split("/")
		var actionId = urlParts[urlParts.length - 1];
		if (actionId == "" || isNaN(actionId)) { // is non-integer
			actionId = 0; // return default action id
		}
		return actionId;
	}

	async reportTraagheid() {
		const actionId = this.getActionId();
		const url = 'api/Report/ReportSlowness/' + actionId;
		let postData = { };
		fetch(url, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(postData) })
			.then(response => {
				if (response.ok) {
					console.log(response);
				}
			}
		);
		alert("Melding van traagheid is verzonden.")
	}

	renderThemeOption(theme) {
		return (<NavDropdown.Item onClick={(e) => { this.setTheme(e, theme.name) }} active={this.props.theme == theme.name}>{theme.name}</NavDropdown.Item>);
    }

	renderAuthorizedMenuItems () {
		return (<div>
			<Dropdown.Header>Thema</Dropdown.Header>
			{
				this.props.themeOptions != null && this.props.themeOptions.length > 0 && this.props.themeOptions.map(t => { return this.renderThemeOption(t); })
			}
			<NavDropdown.Divider />

		</div>);
	}

	renderAuthenticatedMenu() {

		console.log(this.props);

		var userName = this.props.userName;
		if (this.props.runAsUser !== null) {
			userName = <span>{this.props.userName} (Run as: {this.props.runAsUser})</span>;
		}

		return (<NavDropdown title={userName} id="collasible-nav-dropdown">

			{this.props.isAuthorized ? this.renderAuthorizedMenuItems() : null}

			<NavDropdown.Item onClick={(e) => { navigateTo(e, "/account/logout") }} >{this.props.translate('signOut')}</NavDropdown.Item>
		</NavDropdown>);
	}

	renderLoadTimeReporting() {
		if (!this.props.isAuthenticated) {
			return "";
		}

		// is in ErvaarTraagheidMelder groep
		if (this.props.roles == null || !this.props.roles.includes("ErvaarTraagheidMelder")) {
			return "";
		}

		return (<Nav.Link onClick={this.reportTraagheid.bind(this)}>Ik ervaar traagheid</Nav.Link>)
	}

	renderUnauthenticatedMenu() {
		return <Nav.Link onClick={(e) => { navigateTo(e, "/account/login") }}>{this.props.translate('signIn')}</Nav.Link>;
	}

	render() {
		const className = "portalNavbar" + (this.props.isAuthenticated ? "" : " not-loggedin");

		return (<Navbar className={className}>
			<Navbar.Brand href="#home"><div className="logo-placeholder">{this.props.logoUrl != null ? <img src={this.props.logoUrl} alt="" /> : null}</div></Navbar.Brand>

			{this.renderLoadTimeReporting()}
			<Navbar.Collapse className="navbar-account justify-content-end">

				{this.props.isAuthenticated ? this.renderAuthenticatedMenu() : this.renderUnauthenticatedMenu()}

			</Navbar.Collapse>
		</Navbar>);
	}
}

const mapStateToProps = state => ({
	...state.account,
	...state.theme,
	...state.notifications,
	translate: getTranslate(state.localize)
});


export default connect(mapStateToProps, dispatch => bindActionCreators({ ...notificationActions, ...accountActions, ...themeOptionsActions }, dispatch))(Header);



// WEBPACK FOOTER //
// ./src/components/Layout/Header.js